'use client'

import DropDownFooter, { DropDownFooterProps } from '@/components/ui/wizard/DropDownFooter'
import classNames from 'classnames'
import React, { ReactElement, ReactNode, useEffect } from 'react'

interface DropDownProps extends DropDownFooterProps {
  additionalClassName: string
  children: ReactNode
  footerOptions?: ReactNode
  primaryActionLabel?: string
  searchWizard: boolean | undefined
  setHovered?: (hovered: boolean) => void
}

export default function DropDown(props: DropDownProps): ReactElement {
  const mapLayoutABTestGroupB = true && props.searchWizard
  // useWithinGroupB(Experiment.SearchWithoutMap) && props.searchWizard

  useEffect(() => {
    document.querySelector('body')?.classList.add('drop-down-open')

    return () => document.querySelector('body')?.classList.remove('drop-down-open')
  })

  return (
    <div
      onMouseEnter={() => props.setHovered?.(true)}
      onMouseLeave={() => props.setHovered?.(false)}
      className={classNames(
        'z-50 h-screen overflow-x-hidden md:h-auto',
        {
          "wd:mt-2.5 wd:inline-block wd:h-['auto'] wd:h-auto wd:h-auto wd:rounded-md wd:bg-white wd:pt-2 wd:text-md wd:shadow-[0_2px_20px_rgba(0,0,0,0.3)] wm:h-full":
            props.searchWizard && !props.absolutePositioned,
          'lg:top-0 wd:left-0':
            props.searchWizard && !props.absolutePositioned && !mapLayoutABTestGroupB,
          "wdl:left-0 wdl:top-[-5px] wdl:mt-2.5 wdl:inline-block wdl:h-['auto'] wdl:h-auto wdl:h-auto wdl:rounded-md wdl:bg-white wdl:pt-2 wdl:text-md wdl:shadow-[0_2px_20px_rgba(0,0,0,0.3)] wml:h-full":
            !props.searchWizard && !props.absolutePositioned,
          relative: !props.absolutePositioned && !mapLayoutABTestGroupB,
          absolute: mapLayoutABTestGroupB,
          'absolute left-0 z-50 h-auto lg:top-[44px] wd:mt-2.5 wd:inline-block wd:rounded-md wd:bg-white wd:pt-2 wd:text-md wd:shadow-[0_2px_20px_rgba(0,0,0,0.3)] wm:w-[100vw] wm:w-full':
            props.absolutePositioned,
          'w-screen': !props.absolutePositioned,
        },
        props.additionalClassName,
      )}
      onClick={(e) => e.stopPropagation()}
    >
      {props.children}
      <DropDownFooter {...props} options={props.footerOptions} />
    </div>
  )
}
